import { ProjectOptions } from '../utils/prompts';

export function generateAppComponent(options: ProjectOptions): string {
  const ext = options.language === 'TypeScript' ? 'tsx' : 'jsx';
  
  switch (options.framework) {
    case 'Next.js':
      // Next.js app/page.tsx
      return `export default function Home() {
  return (
    <main>
      <h1>Welcome to ${options.projectName}</h1>
    </main>
  );
}
`;
    
    case 'Astro':
      return `---
---

<html lang="en">
  <head>
    <meta charset="utf-8" />
    <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
    <meta name="viewport" content="width=device-width" />
    <meta name="generator" content={Astro.generator} />
    <title>${options.projectName}</title>
  </head>
  <body>
    <h1>Welcome to ${options.projectName}</h1>
  </body>
</html>
`;
    
    case 'React':
      return `function App() {
  return (
    <div className="container">
      <h1>Welcome to ${options.projectName}</h1>
      <p>Get started by editing src/App.${ext}</p>
    </div>
  );
}

export default App;
`;
    
    case 'Vue': {
      const lang = options.language === 'TypeScript' ? 'ts' : 'js';
      return `<template>
  <div class="container">
    <h1>Welcome to ${options.projectName}</h1>
    <p>Get started by editing src/App.vue</p>
  </div>
</template>

<script setup lang="${lang}">
// Your code here
</script>

<style scoped>
.container {
  padding: 2rem;
  text-align: center;
}
</style>
`;
    }
    
    default:
      return '';
  }
}

export function generateNextLayout(options: ProjectOptions): string {
  let cssImport = '';
  switch (options.cssTool) {
    case 'Tailwind CSS':
      cssImport = "import './globals.css'";
      break;
    case 'SCSS':
    case 'CSS':
    default:
      break;
  }
  
  const isTypeScript = options.language === 'TypeScript';
  const typeAnnotation = isTypeScript 
    ? `: {
  children: React.ReactNode
}`
    : '';
  
  return `export const metadata = {
  title: '${options.projectName}',
  description: 'Generated by chi CLI',
}

${cssImport ? cssImport + '\n' : ''}export default function RootLayout({ children }${typeAnnotation}) {
  return (
    <html lang="en">
      <body>
        {children}
      </body>
    </html>
  )
}
`;
}

